import { apiSlice } from "../../../api/ApiService";
import { getHeadersFromRedux } from "../../../utility/functions/common-functions";

const getEducationFiltesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getEducationFilters: builder.query({
      query: ({
        patientPreferredLang
      }) => {
        const headers = getHeadersFromRedux();
        headers["X-Language"] = patientPreferredLang;
        return {
          url: `/api/v1/Patient/learning-filters`,
          method: "GET",
          headers,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetEducationFiltersQuery } = getEducationFiltesApi;
export default getEducationFiltesApi;

